import React, { useState, useEffect, useRef } from "react";
import { get } from "../../services/api";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

function AttendanceCalendarModal({
  isOpen,
  onClose,
  centerId,
  selectedDate,
  onDateSelect,
}) {
  const token = localStorage.getItem("token");
  const [calendars, setCalendars] = useState([]);
  const [currentCalendarDate, setCurrentCalendarDate] = useState(new Date());
  const calendarRef = useRef(null);

  // Fetch calendar data
  const fetchCalendars = async () => {
    if (!centerId) return;

    try {
      const currentYear = new Date().getFullYear();
      const url = `CenterAttendence/GetCalenderHolidays?Year=${currentYear}&CenterId=${centerId}&SessionId=0`;
      const response = await get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCalendars(response.holidays || []);
    } catch (error) {
      console.error("Error fetching calendar data:", error);
      setCalendars([]);
    }
  };

  // Fetch events for FullCalendar
  const fetchEvents = () => {
    return calendars.map((holiday) => ({
      id: holiday.id.toString(),
      title: holiday.name,
      start: holiday.fromDate,
      end: new Date(new Date(holiday.toDate).setHours(23, 59, 59)),
      color: holiday.colorCode || "#3788d8",
      extendedProps: {
        type: holiday.calTypeDesc,
        remarks: holiday.remarks,
        daysCount: holiday.consecutiveDaysCount,
      },
    }));
  };

  // Handle date click in calendar
  const handleDateClick = (arg) => {
    return false;
  };

  // Handle calendar view change
  const handleDatesSet = (arg) => {
    setCurrentCalendarDate(arg.view.currentStart);
  };

  // Navigate to current month
  const navigateToCurrentMonth = () => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.today();
      setCurrentCalendarDate(new Date());
    }
  };

  // Navigate to selected date
  const navigateToSelectedDate = () => {
    if (selectedDate && calendarRef.current) {
      const date = new Date(selectedDate);
      setCurrentCalendarDate(date);
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(date);
    }
  };

  useEffect(() => {
    if (isOpen && centerId) {
      fetchCalendars();
    }
  }, [isOpen, centerId]);

  useEffect(() => {
    if (isOpen && selectedDate) {
      setTimeout(() => {
        navigateToSelectedDate();
      }, 100);
    }
  }, [isOpen, selectedDate]);

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Academic Calendar</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="calendar-container">
              <div className="d-flex justify-content-between align-items-center mb-3"></div>

              <FullCalendar
                ref={calendarRef}
                plugins={[dayGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                initialDate={currentCalendarDate}
                events={fetchEvents()}
                dateClick={handleDateClick}
                datesSet={handleDatesSet}
                dayMaxEvents={1}
                height="auto"
                eventDisplay="block"
                headerToolbar={{
                  left: "prev,next today",
                  center: "title",
                  right: "dayGridMonth",
                }}
                eventContent={(eventInfo) => (
                  <div className="fc-event-content">
                    <div className="fc-event-title">
                      {eventInfo.event.title}
                    </div>
                  </div>
                )}
              />
            </div>

            {/* Calendar Legend */}
            <div className="mt-3">
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex align-items-center mb-1">
                    <div
                      className="color-indicator me-2"
                      style={{
                        width: "12px",
                        height: "12px",
                        backgroundColor: "#3788d8",
                        borderRadius: "2px",
                      }}
                    ></div>
                    <small>Holidays & Events</small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-center mb-1"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        .calendar-container {
          margin-top: 10px;
        }
        .fc-event-content {
          padding: 2px 4px;
          font-size: 0.85em;
        }
        .fc-event-title {
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .color-indicator {
          border: 1px solid #dee2e6;
        }
      `}</style>
    </div>
  );
}

export default AttendanceCalendarModal;
